export const USER_VALIDATION = {
  USER_NOT_OF_AGE: 'USER_NOT_OF_AGE',
  CARDID_BIRTHDAY_DONT_MATCH: 'CARDID_BIRTHDAY_DONT_MATCH',
  VALID: 'VALID',
};

export const MIN_DOCUMENT_SIZE = {
  AR: 7,
};

export const MAX_DOCUMENT_SIZE = {
  AR: 8,
};
